<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>约课管理</Breadcrumb-item>
        <Breadcrumb-item>当天订课信息</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <Col :xs="24" :sm="12" :md="7" :lg="7">
            <Form-item label="上课时间">
              <Row>
                <Col :xs="24" :sm="11" :md="11" :lg="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               @on-change="startTimeDateChange" v-model="queryParam.startTimeDate"/>
                </Col>
                <Col :xs="24" :sm="2" :md="2" :lg="2" style="text-align: center; padding: 5px 0;">-</Col>
                <Col :xs="24" :sm="11" :md="11" :lg="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               @on-change="endTimeDateChange" v-model="queryParam.endTimeDate"/>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="4" :lg="4">
            <Form-item label="学导">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="queryParam.adminUserId"/>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="4" :lg="4">
            <Form-item label="课程顾问">
              <admin-user-select :status="1" adminGroupCode="adviser" v-model="queryParam.adviserId"/>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="4" :lg="4">
            <Form-item label="老师ID">
              <Input name="tchId" v-model="queryParam.tchId"/>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="4" :lg="4">
            <Form-item label="老师姓名">
              <Input placeholder="支持模糊搜索" name="tchName" v-model="queryParam.tchName"/>
            </Form-item>
          </Col>
          <!-- 其他表单项类似处理 -->
        </Row>
        <Row>
          <Col :xs="24" :sm="12" :md="4" :lg="4">
            <Form-item label="学生ID">
              <Input name="uid" v-model="queryParam.uid"/>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="4" :lg="4">
            <Form-item label="外教运营">
              <Select
                v-model.number="queryParam.tchStudyAdviserId"
                placeholder="全部"
                @on-change="search"
                clearable
                style="width: 100%"
              >
                <Option v-for="item in tchStudyAdviserList"
                        :value="item.id" :key="item.id">{{ item.nickname }}
                </Option>
              </Select>
            </Form-item>
          </Col>
        </Row>

        <Row>
          <Col :xs="24" :sm="12" :md="6" :lg="6">
            <Form-item :label-width="50">
              <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">
                搜索
              </Button>
              <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search" v-perm="'619'"
                      @click="exportData">导出
              </Button>
            </Form-item>
          </Col>
        </Row>

      </Form>

    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookLesson/opened/take-list" class="opened-list"
          :params="queryParam" :onLoading="onLoading" :reloadWithPage="reloadWithPage" operator=""
          @on-selection-change="selectedChange"/>
    <UserInfoModal :value="editUser" @on-close="closeModal" :uid="uid" :successCallback="searchWithPage"/>
    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId"/>
  </div>
</template>
<style>
.opened-list .ivu-table-cell {
  padding-left: 8px;
  padding-right: 8px;
}
.opened-list .ivu-table td {
  padding: 0 !important;
}

.opened-list .ivu-table-cell {
  padding: 0 !important;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<script>
import ChangeLessonModal from './ChangeLessonModal.vue'
import ChangeClassTypeModal from './ChangeClassTypeModal.vue'
import AddMonitorLessonRecordModal from './modal/AddMonitorLessonRecordModal.vue'
import TchLessonLeaveModal from '../teacher/TchLessonLeaveModal.vue'
import LessonCancelModal from '../lesson/LessonCancelModal.vue'
import UserOneLeaveModal from './UserOneLeaveModal.vue'
import UserInfoModal from '../crm/UserInfoModal.vue'
import TchInfoModal from '../teacher/modal/TchInfoModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
import dates from '@/tools/date/dates.js'
import LessonFeedBackModal from './LessonFeedBackModal.vue'
import SearchChangeTchModal from './modal/SearchChangeTchModal.vue'
import UserTempLessonModal from '../user/modal/UserTempLessonModal.vue'

export default {
  components: {
    UserTempLessonModal,
    LessonFeedBackModal,
    ChangeLessonModal,
    ChangeClassTypeModal,
    AddMonitorLessonRecordModal,
    TchLessonLeaveModal,
    LessonCancelModal,
    UserOneLeaveModal,
    UserInfoModal,
    SearchChangeTchModal,
    TchInfoModal,
  },
  data: function () {
    let $constant = this.$constant
    let $moment = this.$moment
    return {
      searchLoading: false,
      rankScoreSeq: 0,
      exportLoading: false,
      editUser: false,
      uid: null,
      showTchInfoModal: false,
      unifiedHolidayModal: false,
      showSearchChangeTchModal: false,
      showUserTempLessonModal: false,
      changeTeacherOnly: false,
      optType: 0,
      tchId: null,
      userNickname: '',
      reload: 0,
      reloadWithPage: 0,
      param: {
        date: dates.today(),
        studyAdviserId: '',
        keywords: '',
        totalCount: 0,
        isAudition: null,
        category: null,
        tchType: null,
        accent: null,
        sex: null,
        pageIndex: 1,
        pageSize: 20,

      },
      queryParam: {
        tchId: '',
        tchName: '',
        tchEmail: '',
        materialVersionId: '',
        isStudyAdviser: '',
        uid: '',
        userMobile: '',
        userNickname: '',
        adviserNickname: '',
        studyAdviserNickname: '',
        tchCategory: '',
        lsnSelStatus: '',
        lsnType: '',
        courseType: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        startCreateDate: '',
        endCreateDate: '',
        startCreateTime: '',
        endCreateTime: '',
        adviserId: '',
        adviserIds: [],
        operatorIds: [],
        regStartDate: '',
        regEndDate: '',
        regStartTime: '',
        regEndTime: '',
        creatorName: '',
        adminUserId: '',
        regType: '',
        tchChannel: '',
        tchStudyAdviserId: '',
        checkStatus: ''
      },
      holidayParam: {
        startTime: '',
        endTime: '',
        content: ''
      },
      tempLessonUser: {},
      holidayRule: {
        startTime: [
          {required: true, message: '请选择开始时间', trigger: 'blur'},
        ],
        endTime: [
          {required: true, message: '请选择结束时间', trigger: 'change'}
        ],
        content: [
          {required: true, max: 100, message: '长度不要超过100个字符', trigger: 'blur'}
        ],
      },
      tchStudyAdviserList: [],
      selectionOpenedIds: [],
      openedId: null,
      lsnType: null,
      openId: null,
      lessonOpened: {},
      classType: null,
      lessonTitle: null,
      lsnBeginTime: null,
      showChangeLessonModal: false,
      showChangeLClassTypeModal: false,
      showMonitorLessonRecordModal: false,
      showTchLessonLeaveModal: false,
      showLessonCancelModal: false,
      showLessonFeedBackModal: false,
      tchChannel: null,
      showUserOneLeaveModal: false,
      title: [
        {
          title: '课程ID',
          align: 'center',
          width: 80,
          key: 'id',
        },
        {
          title: '课程内容',
          width: 140,
          render: (h, params) => {
            let row = params.row
            let lsnType = row.lsnType
            let title = row.lessonTitle
            let lsnTypeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
            let courseType = row.courseType
            let typeEnum = $constant.getEnum($constant.courseType, courseType)
            let cType = typeEnum && typeEnum.text
            if (cType) {
              cType = '课程类别：' + cType
            } else {
              cType = ''
            }
            return h('div', {style: {'font-size': '13px'}}, [h('p', {style: {color: '#2d8cf0'}}, title),
              h('p', '课程类型：' + (lsnTypeEnum && lsnTypeEnum.text)),
              h('p', cType)])
          }
        },
        {
          title: '课程等级',
          align: 'center',
          width: 120,
          key: 'levelTitle'
        },
        {
          title: '开课日期',
          align: 'center',
          width: 170,
          render: (h, params) => {
            const lsnBeginTime = params.row.lsnBeginTime
            const isHighlighted = params.row.firstLesson || false
            // 确保填充整个单元格的样式
            const cellStyle = {
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              ...(isHighlighted ? { backgroundColor: '#adf3c1' } : {})
            }
            return h('div', { style: cellStyle }, $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm'))
          }
        },
        {
          title: '课程状态',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let lsnSelStatus = params.row.lsnSelStatus
            let statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus)
            return h('span', statusEnum && statusEnum.text)
          }
        },
        {
          title: '当前老师',
          align: 'center',
          width: 200,
          render: (h, params) => {
            let row = params.row
            let isChange = ''
            if (row.isNewTch === 1) {
              isChange = '(替)'
            }
            return renderTchNameWithScore(h, {
              text: row.tchId + '-' + row.tchFirstName + ' ' + row.tchLastName + isChange,
              score: row.monthRankScore,
              onClick: () => this.openNewLessonModal(row.tchId, row.tchFirstName + row.tchLastName)
            })
          }
        },
        {
          title: '是否代课',
          align: 'center',
          width: 72,
          render: (h, params) => {
            let isNewTch = params.row.isNewTch
            if (isNewTch > 0) {
              return h('div', '是')
            } else {
              return h('div', '否')
            }
          }
        },
        {
          title: '学生ID、姓名',
          align: 'center',
          width: 150,
          render: (h, params) => {
            let row = params.row
            return h('a', {on: {click: () => this.openInfoModal(row.uid)}}, row.uid + '-' + row.userNickname)
          }
        },
        {
          title: '学导',
          align: 'center',
          width: 110,
          key: 'studyAdviserNickname'
        },
        {
          title: '课程顾问',
          width: 110,
          key: 'adviserNickname'
        },
        {
          title: '外管',
          align: 'center',
          width: 110,
          key: 'tchStudyName'
        },
        {
          title: '外教是否确认',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let checkStatus = params.row.checkStatus
            let statusEnum = $constant.getEnum($constant.checkStatus, checkStatus)
            let color = '#909399' // 默认灰色
            if (checkStatus === 1) {
              color = 'green' // 已确认 - 绿色
            } else if (checkStatus === 2) {
              color = 'red' // 已拒绝 - 红色
            }
            return h('span', {
              style: {
                color: color,
                'font-weight': '500 !important'
              }
            }, statusEnum && statusEnum.text)
          }
        }
      ]
    }
  },
  mounted: function () {
    this.init()
    let self = this
    let queryParam = this.queryParam
    queryParam.uid = this.$route.query.uid
    this.$http.post('/adminUser/listByCondition', {adminGroupId: 7}).then(function (res) {
      self.tchStudyAdviserList = res.data
    })
    this.initStartTime()
  },
  created: function () {
    this.initStartTime()
  },
  methods: {
    initStartTime() {
      // 设置默认时间为当天开始和结束时间
      const todayStart = this.$moment().startOf('day')
      const todayEnd = this.$moment().endOf('day')

      // 设置开始时间（当天 00:00:00）
      this.queryParam.startTimeDate = todayStart.toDate()
      this.queryParam.startTime = todayStart.format('X')

      // 设置结束时间（当天 23:59:59）
      this.queryParam.endTimeDate = todayEnd.toDate()
      this.queryParam.endTime = todayEnd.format('X')
    },
    init() {
      let self = this
      let query = self.$route.query
      if (query) {
        if (query.regStartDate) {
          self.queryParam.regStartDate = parseInt(query.regStartTime) * 1000
        }
        if (query.regEndDate) {
          self.queryParam.regEndDate = parseInt(query.regEndTime) * 1000
        }
        if (query.startTimeDate) {
          self.queryParam.startTimeDate = parseInt(query.startTime) * 1000
        }
        if (query.endTimeDate) {
          self.queryParam.endTimeDate = parseInt(query.endTime) * 1000
        }
        if (query.startCreateDate) {
          self.queryParam.startCreateDate = parseInt(query.startCreateTime) * 1000
        }
        if (query.endCreateDate) {
          self.queryParam.endCreateDate = parseInt(query.endCreateTime) * 1000
        }
        if (query.tchId) {
          self.queryParam.tchId = parseInt(query.tchId)
        }
        if (query.tchName) {
          self.queryParam.tchName = query.tchName
        }
        if (query.materialVersionId) {
          self.queryParam.materialVersionId = parseInt(query.materialVersionId)
        }
        if (query.isStudyAdviser) {
          self.queryParam.isStudyAdviser = query.isStudyAdviser
        }
        if (query.uid) {
          self.queryParam.uid = parseInt(query.uid)
        }
        if (query.userMobile) {
          self.queryParam.userMobile = query.userMobile
        }
        if (query.userNickname) {
          self.queryParam.userNickname = query.userNickname
        }
        if (query.adviserNickname) {
          self.queryParam.adviserNickname = query.adviserNickname
        }
        if (query.studyAdviserNickname) {
          self.queryParam.studyAdviserNickname = query.studyAdviserNickname
        }
        if (query.tchCategory) {
          self.queryParam.tchCategory = parseInt(query.tchCategory)
        }
        if (query.lsnSelStatus) {
          self.queryParam.lsnSelStatus = parseInt(query.lsnSelStatus)
        }
        if (query.lsnType) {
          self.queryParam.lsnType = parseInt(query.lsnType)
        }
        if (query.courseType) {
          self.queryParam.courseType = parseInt(query.courseType)
        }
        if (query.adviserId) {
          self.queryParam.adviserId = parseInt(query.adviserId)
        }
        if (query.creatorName) {
          self.queryParam.creatorName = query.creatorName
        }
        if (query.checkStatus) {
          self.queryParam.checkStatus = parseInt(query.checkStatus)
        }
      }
    },
    openTchInfoModal(val, classIn) {
      this.tchId = val
      this.showTchInfoModal = true
    },
    search() {
      this.selectionOpenedIds = []
      this.reload = new Date().getTime()
    },
    exportData() {
      this.exportLoading = true
      this.$http.get('/bookLesson/opened/take-list-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '当天订课信息.csv'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    },
    searchWithPage() {
      this.reloadWithPage = new Date().getTime()
    },
    closeModal(val) {
      this.uid = null
      this.editUser = false
      this.UserOneLeaveModal = val
    },
    openInfoModal(val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/lesson/BookLessonTempList'}
      })
      window.open(href, '_blank')
    },
    openNewLessonModal(k, v) {
      window.open('http://bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v)
    },
    onLoading (loading) {
      this.searchLoading = loading
      if (!loading) {
        this.loadMonthRankScores()
      }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },
    startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    startCreateTimeChange(value) {
      this.queryParam.startCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endCreateTimeChange(value) {
      this.queryParam.endCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    startTimeRegChange(value) {
      this.queryParam.regStartTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeRegChange(value) {
      this.queryParam.regEndTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    startTimeHolidayChange(value) {
      this.holidayParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeHolidayChange(value) {
      this.holidayParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    onUserLeave(id) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 请假？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/bookUserLeaveTime/addByOpenedId', {openedId: id}).then(function (res) {
            if (res) {
              self.search()
              self.$Message.success('请假成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    onTchLeave(id) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>老师</b> 请假？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookTchLeaveTime/addByOpenedId', {openedId: id}).then(function (res) {
            if (res) {
              self.search()
              self.$Message.success('请假成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    onUserAbsent(row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 旷课？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/userAbsent', {id: row.id}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    onConfirmMakeUp(row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 补课？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/confirmMakeUp', {id: row.id}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    onTchAbsent(row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>老师</b> 旷课？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/tchAbsent', {id: row.id}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    onReloadClassIn(row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确定 手动生成ClassIn ID ？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/user/lesson/reloadClassIn', {openedId: row.id}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('生成成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    closeRecordScreen(row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>关闭</b>录屏？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/updateRecordScreen', {openedId: row.id, isRecordScreen: 0}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    openRecordScreen(row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>开启</b>录屏？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/updateRecordScreen', {openedId: row.id, isRecordScreen: 1}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    viewRecordScreen(row) {
      window.open(row.liveUrl)
      // this.$http.get('/bookLesson/getRecordScreenUrl?openedId=' + row.id).then(function (res) {
      //   window.open(res.data)
      // })
    },
    lessonFeedBack(row) {
      this.openedId = row.id
      this.uid = row.uid
      this.tchId = row.tchId
      this.userNickname = row.userNickname
      this.showLessonFeedBackModal = true
    },
    selectedChange(selection) {
      this.selectionOpenedIds = selection
    },
    batchCancelLesson() {
      if (this.selectionOpenedIds.length <= 0) {
        this.$Message.warning('请选择需要取消的课程！')
        return
      }
      let self = this
      let ids = []
      let startedCount = 0
      let now = Date.now()
      if (this.selectionOpenedIds && this.selectionOpenedIds.length > 0) {
        for (let i in this.selectionOpenedIds) {
          let dto = this.selectionOpenedIds[i]
          if (dto.lsnSelStatus === 2 || dto.lsnBeginTime * 1000 <= now) {
            startedCount++
          } else {
            ids.push(dto.id)
          }
        }
      }
      if (startedCount > 0) {
        this.$Message.warning('课程已开始，不可取消')
      }
      if (ids.length <= 0) {
        return
      }
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认取消已选课程？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/bookLesson/batchCancelLesson', {
            openedIds: ids.join(','),
            reason: '管理员取消'
          }).then(function (res) {
            self.search()
            self.$Message.success('操作成功!')
            self.$Modal.remove()
          })
        }
      })
    },
    saveHoliday() {
      let self = this
      let holidayValidate = 0
      if (this.holidayParam.startTime && this.holidayParam.startTime !== '') {
        holidayValidate += 1
      }
      if (this.holidayParam.endTime && this.holidayParam.endTime !== '') {
        holidayValidate += 1
      }
      if (this.holidayParam.content && this.holidayParam.content !== '') {
        holidayValidate += 1
      }
      if (holidayValidate !== 3) {
        return
      }
      self.$http.post('/holiday/insert', this.holidayParam).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('新增成功!')
          self.unifiedHolidayModal = false
          self.successCallback()
        } else {
          self.$Message.error('新增失败!')
        }
      }).catch(function (e) {
      })
    },
    cancelProxy(row) {
      let self = this
      self.tempLessonUser = row
      self.showSearchChangeTchModal = true
      self.changeTeacherOnly = true
      self.optType = 3
    }
  },
}
</script>



// WEBPACK FOOTER //
// BookLessonTempList.vue?f033dd14